import { render, staticRenderFns } from "./DummyPage.vue?vue&type=template&id=88cf9b4e&scoped=true"
import script from "./DummyPage.vue?vue&type=script&lang=js"
export * from "./DummyPage.vue?vue&type=script&lang=js"
import style0 from "./DummyPage.vue?vue&type=style&index=0&id=88cf9b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cf9b4e",
  null
  
)

export default component.exports